export default __webpack_public_path__ + "static/media/search.2a8fdd83.svg";